var exports = {
  "Xe": "FluxerTagChangeModal.module__confirmDescription___SWJ1NF",
  "z8": "FluxerTagChangeModal.module__confirmSecondary___SWJ1NF",
  "O7": "FluxerTagChangeModal.module__fluxerTagContainer___SWJ1NF",
  "To": "FluxerTagChangeModal.module__fluxerTagLabel___SWJ1NF",
  "Nr": "FluxerTagChangeModal.module__fluxerTagInputRow___SWJ1NF",
  "jo": "FluxerTagChangeModal.module__usernameInput___SWJ1NF",
  "me": "FluxerTagChangeModal.module__separator___SWJ1NF",
  "vb": "FluxerTagChangeModal.module__discriminatorInput___SWJ1NF",
  "xU": "FluxerTagChangeModal.module__discriminatorInputDisabled___SWJ1NF",
  "d0": "FluxerTagChangeModal.module__discriminatorOverlay___SWJ1NF",
  "Ye": "FluxerTagChangeModal.module__errorBox___SWJ1NF",
  "jY": "FluxerTagChangeModal.module__validationBox___SWJ1NF",
  "KF": "FluxerTagChangeModal.module__premiumDiscriminatorWarning___SWJ1NF",
  "Lu": "FluxerTagChangeModal.module__premiumUpsell___SWJ1NF",
};

module.exports = exports;
